class QuotationVisitorFacebook {
    /** @ngInject */
    constructor(DeviceChecker) {
        this.isMobile = DeviceChecker.isMobile
    }

    clickOnIframeFacebook() {
        this.onDispatch({ $event: { type: 'CLICK_ON_VISITOR_FACEBOOK' } })
    }
}

export default {
    template: require('./quotationVisitorFacebook.jade')(),
    controller: QuotationVisitorFacebook,
    bindings: {
        store: '<',
        onDispatch: '&',
    },
}



// WEBPACK FOOTER //
// ./src/states/quotation/component/quotationVisitorFacebook.js